var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import apiClient from '@utils/api-client';
import { translate } from '@utils/i18n';
const NAMESPACE = 'features.settings.integrations.tce_template_diagnostic';
const firstUserMessage = (response) => { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = response.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.messages) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.userMessage) !== null && _e !== void 0 ? _e : null; };
/**
 * Runs the TCE report-template diagnostic for one premise on demand.
 *
 * Deliberately not auto-fetching: every call is a live request to TCE, so it
 * fires only when someone asks for it.
 */
const useTceTemplateDiagnostic = () => {
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const run = (premiseId, inspectionId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        setLoading(true);
        setError(null);
        try {
            const response = yield apiClient.get('/tce/template_diagnostic', {
                params: { premiseId, inspectionId }
            });
            const remoteError = firstUserMessage(response.data);
            const diagnostic = {
                tceHost: (_a = response.data.tceHost) !== null && _a !== void 0 ? _a : null,
                credentialContext: (_b = response.data.credentialContext) !== null && _b !== void 0 ? _b : null,
                codeTypes: (_c = response.data.codeTypes) !== null && _c !== void 0 ? _c : [],
                templates: (_d = response.data.templates) !== null && _d !== void 0 ? _d : []
            };
            setError(remoteError);
            setResult(remoteError !== null && diagnostic.templates.length === 0 ? null : diagnostic);
        }
        catch (_e) {
            setResult(null);
            setError(translate('error', { namespace: NAMESPACE }));
        }
        finally {
            setLoading(false);
        }
    });
    return { result, loading, error, run };
};
export default useTceTemplateDiagnostic;
